import {
  Ban,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleDot,
  CircleHelp,
  CircleMinus,
  CirclePlus,
  CircleX,
  Clock,
  CloudAlert,
  CloudOff,
  Copy,
  History,
  Lock,
  Pencil,
  RefreshCw,
  ShieldAlert,
  Tags,
  Trash2,
  TriangleAlert,
  type LucideIcon,
} from 'lucide-react';
import type { StatusId } from './model';

const ICONS: Record<StatusId, LucideIcon> = {
  'name-conflict': TriangleAlert,
  'rotation-conflict': TriangleAlert,
  rotated: RefreshCw,
  'older-version': History,
  'rolling-out': RefreshCw,
  'no-value': CircleAlert,
  disabled: Ban,
  'deleted-outside': Trash2,
  'access-denied': ShieldAlert,
  'not-found': CircleX,
  invalid: CircleX,
  'vault-unreachable': CloudOff,
  'changed-outside': TriangleAlert,
  'cloud-changed': CloudAlert,
  expired: Clock,
  'tags-edited': Tags,
  'plain-in-cloud': Copy,
  unreachable: CloudOff,
  changed: CircleDot,
  added: CirclePlus,
  removed: CircleMinus,
  'not-applied': CircleDashed,
  unsaved: Pencil,
  'stale-value': Clock,
  pending: CircleDashed,
  resolved: CircleCheck,
  applied: CircleCheck,
  'read-only': Lock,
  unknown: CircleHelp,
  'request-not-attached': TriangleAlert,
  'request-unresolved': TriangleAlert,
  'request-ambiguous': CircleHelp,
  'request-blocked': Ban,
};

export function statusIcon(id: StatusId): LucideIcon {
  return ICONS[id];
}
